import * as S from './styles'
import { usePartners } from './usePartners'
import { Text } from '@/components'
import { Partner } from '@/service/api/home'

type PartnersContainerProps = {
  /**
   * Data of partners container
   *
   * @example
   * ```tsx
   * const data = {
   *  ...
   * }
   *
   * <PartnersContainer partnerData={data} />
   * ```
   */
  partnerData: Partner
}

export const PartnersContainer: React.FC<PartnersContainerProps> = ({
  partnerData,
}) => {
  const { fontSizes } = usePartners()

  const topLogos = partnerData.logos.slice(
    0,
    Math.trunc(partnerData.logos.length / 2),
  )
  const bottomLogos = partnerData.logos.slice(
    Math.trunc(partnerData.logos.length / 2),
    partnerData.logos.length,
  )

  if (!partnerData) return null

  return (
    <S.PartnerContainer>
      {partnerData.heading && (
        <Text align="center" size={fontSizes.title} color="primary">
          {partnerData.heading}
        </Text>
      )}

      <div className="logos">
        <div className="row">
          {topLogos.map((partner) => (
            <S.ImageLogos
              key={partner.alt}
              src={partner.src}
              alt={partner.alt}
              height={partner.defaultSize.height}
              width={partner.defaultSize.width}
              style={{
                maxWidth: partner.defaultSize.width,
              }}
            />
          ))}
        </div>
        <div className="row">
          {bottomLogos.map((partner) => (
            <S.ImageLogos
              key={partner.alt}
              src={partner.src}
              alt={partner.alt}
              height={partner.defaultSize.height}
              width={partner.defaultSize.width}
              style={{
                maxWidth: partner.defaultSize.width,
              }}
            />
          ))}
        </div>
      </div>
    </S.PartnerContainer>
  )
}
